//firebase.js
//import { initializeApp } from "firebase/app";
import "firebase/compat/auth";
import "firebase/compat/storage";
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/app-check';
import firebase from "firebase/compat/app";
//import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDgfoioxPkPe5wJHuNC7gzy1QGNhCJNqJ0",
  authDomain: "elec-construction.firebaseapp.com",
  projectId: "elec-construction",
  storageBucket: "elec-construction.appspot.com",
  messagingSenderId: "464367193990",
  appId: "1:464367193990:web:8106ca2aca70f56bd86607",
  measurementId: "G-HSEJW9MG3P"
};

// firebaseConfig 정보로 firebase 시작
const firebaseApp = firebase.initializeApp(firebaseConfig);
//const firebaseAuth = getAuth(firebaseApp);

// ── App Check (2026-08-26 보안점검) ───────────────────────────
// 앱(Android/iOS)은 Play Integrity / App Attest 로 이미 토큰을 보내는데
// 관리자웹만 초기화 코드가 없어 요청이 UNKNOWN(MISSING_*) 으로 집계되고 있었다.
// 강제(Enforce)를 켜면 이 웹만 전면 차단되므로, 강제 이전에 토큰부터 보내게 한다.
//
// 사이트 키는 브라우저에 노출되는 공개값이다(도메인 제한으로 보호).
//   키: elec-construction-appcheck (프로젝트 elec-construction, SCORE 모드)
//   허용 도메인: elec-construction.web.app / elec-construction-web-app.web.app / localhost
//
// ⚠️ 현재 4개 서비스 모두 UNENFORCED 이므로 이 코드가 있든 없든 요청은 통과한다.
//    강제 전환은 1~2주 지표(MISSING_* 감소) 확인 후 별도로 진행한다.
const APP_CHECK_SITE_KEY = '6Le8JZktAAAAAEx8pk1EWIueJ6Ir3Yi-Zj1v3kkq';
try {
  firebase.appCheck().activate(
    new firebase.appCheck.ReCaptchaEnterpriseProvider(APP_CHECK_SITE_KEY),
    true, // 토큰 자동 갱신
  );
} catch (e) {
  // 초기화 실패가 관리자웹 전체를 막지 않도록 한다.
  // (UNENFORCED 동안에는 토큰이 없어도 요청이 통과하므로 fail-soft 가 안전하다)
  console.warn('[AppCheck] activate 실패:', e);
}

const firestore = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const authPersistence = firebase.auth.Auth.Persistence;
const funtions = firebase.functions();
//const auth = getAuth();

export { firebaseApp, firestore, auth, storage, authPersistence, funtions };